// extracted by mini-css-extract-plugin
export default {"pageContainerWithHeader":"pageContainer_pageContainerWithHeader__ciUIa","pageContainer":"pageContainer_pageContainer__IkGnF"};